/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  Output,
  EventEmitter,
  NgModuleRef,
  ComponentFactoryResolver,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as _ from 'lodash';
import { saveAs } from 'file-saver';
import { AttachDocumentsService } from '../../services/attach-documents.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { TableSortService } from '../../services/table-sort.service';
import { TranslateService } from '@ngx-translate/core';
import { File as CustomFile } from '../../interfaces/base-core-services.interface';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ProfileManagementService } from 'src/app/business/intelligencemgmt-ui/services/profile-management.service';
import { DateTimeService } from 'src/app/shared-resources/services/date-time.service';
import { DateFormat } from 'src/app/shared-resources/interfaces/base-core-services.interface';

@Component({
  selector: 'lib-attach-documents',
  templateUrl: './attach-documents.component.html',
  styleUrls: [],
})
export class AttachDocumentsComponent implements OnInit, OnChanges {
 @Input()
  set files(value: CustomFile[] | any[]) {
    value.forEach((file) => {
      return this.updateFileParam(file);
    });
    this.attachedFiles = value;
  }
  @Input() set id(value: string) {
    if (value !== null && value !== undefined && ('' + value)?.length > 0 && value !== 'undefined') {
      this._id = '' + value;
      // Defer getDocumentsDetails so that other @Input bindings (like version) are set first
      setTimeout(() => {
        if (this.urlId) {
          this.getDocumentsDetails();
        }
      });

      if (this._id) {
        this.setActionUrl();
        if (this.currentAction !== 'amend') {
          this.uploadAmendDocument();
        }
      }
    }
  }
  @Input()
  set readOnly(value: boolean) {
    this.read = value;
    if (this.urlId) {
      this.getDocumentsDetails();
    }
  }

  @Input() disabled=false;

  @Input()
  set alreadyUploadDocs(value: boolean) {
    this.listWithUpload = value;
    if (this.urlId) {
      this.getDocumentsDetails();
    }
  }

  @Input() public fileTypes: any[] = [];
  @Input() public downloadEndpoint = '/dms/api/v1/attachments'; // Optional with default value
  @Input() public deleteDocUrl = '/api/v1/documents?uuids=:id';
  @Input() public title = 'Attachments';
  @Input() public noTitle = false;
  @Input() public isAnyMandatory = false;
  @Input() public subModule = '';
  @Input() public module = '';
  @Input() public multiple = true;
  @Input() public token = '';
  @Input() public baseUrl = '';
  @Input() maxFileSizeMB = 1; // default 1MB
  @Input() maxFiles = 5;
  @Input() isShowTable = true;
  @Input() currentAction: string;
  @Input() riskStatus: string;
  @Input() formData:any
  @Input() version: any = '';

  @Output() public fileData = new EventEmitter();
  @Output() public deleteFile = new EventEmitter();
  @Output() getFileList = new EventEmitter<any>();
  @Output() uploadComplete = new EventEmitter<any>();
  private _id = '';
  private attachmentsGroup: FormGroup;
  public actionUrl = '';
  public docType: any;
  public nzFileType = '';
  public nzSize = 0;
  public nzShowButton = false;
  public nzShowUploadList = false;
  public attachedFiles: any[] = [];
  public isSpinning = false;
  read = false;
  public listWithUpload = false;
  urlId:any;
  isDragOver = false;

  constructor(
    private attachmentsService: AttachDocumentsService,
    private formBuilder: FormBuilder,
    private tableSortService: TableSortService,
    private msg: NzMessageService,
    private modalService: NzModalService,
    private translate: TranslateService,
    private resolver: ComponentFactoryResolver,
    private activatedRoutes: ActivatedRoute,
    private profileMgtService: ProfileManagementService,
    private dateTimeService: DateTimeService,
    private router: Router
  ) {
    if (!this.module) {
      const factory = resolver.resolveComponentFactory(AttachDocumentsComponent);
      const ngModuleRef: NgModuleRef<any> = (factory as any).ngModule;
      //this.module = ngModuleRef.instance.constructor.name;
    }
  }

  ngOnInit(): void {
    this.activatedRoutes.params.subscribe(params => {
      this.urlId = params['id'];
      if (this.urlId && this._id) {
        this.getDocumentsDetails();
      }
    });
    this.attachmentsGroup = this.formBuilder.group({
      docType: null,
      attachments: '',
    });
    this.deleteDocUrl = this.baseUrl + this.deleteDocUrl;
  }

  onDocTypeChanges(value: string): void {
    this.setActionUrl();
    const [item]: any = this.fileTypes.filter((x: any) => {
      return x.fileName == value;
    });

    if (item) {
      this.nzFileType = item.fileType;
      this.nzSize = item.sizeKB;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this._id !== null && this._id?.length > 0 && !this.read && this.currentAction !== 'amend') {
      this.setActionUrl();
      this.uploadAmendDocument();
    }

    if (changes['files'] && changes['files'].currentValue) {
      this.attachedFiles = changes['files'].currentValue;
    }

    if (changes['fileTypes'] && changes['fileTypes'].currentValue) {
      if (
        this.attachmentsGroup &&
        this.attachmentsGroup.value &&
        this.attachmentsGroup.value.docType
      ) {
        this.attachmentsGroup.patchValue({ docType: null });
      }

      this.fileTypes = changes['fileTypes'].currentValue;
    }
  }

  setActionUrl() {
    if (this._id) {
      this.actionUrl = `${this.baseUrl}/api/v1/attachments/upload/${this._id}/${this.module}${this.subModule}/${(this.docType)? this.docType :  "product"}`;
    }
  }

  sort(sort: any): void {
    this.attachedFiles = this.tableSortService.getSortedData(sort, this.attachedFiles);
    this.attachedFiles = [...this.attachedFiles];
  }

  deleteAttachment(obj: any): void {
    const uploadDoc = this._id !== null && this._id?.length > 0 ? true : false;
    // return;
    this.modalService.confirm({
      nzTitle: this.translate.instant('app.action.confirm'),
      nzContent: this.translate.instant('app.message.delete'),
      nzOkText: this.translate.instant('app.action.ok'),
      nzCancelText: this.translate.instant('app.label.cancel'),
      nzOnOk: () => {
        if (uploadDoc) {
          this.attachmentsService.deleteDocument(this.deleteDocUrl.replace(':id', obj.docAttachmentFileId)).subscribe((res: any) => {
              if (!res.errors || res.errors?.length <= 0) {
                this.deleteInlineAttachment(obj);
                if (obj.docAttachmentFileId) this.deleteFile.emit(obj.docAttachmentFileId);
              } else {
                this.msg.error(res.errors[0].message);
              }
            });
        } else {
          this.deleteInlineAttachment(obj);
          if (obj.docAttachmentFileId) this.deleteFile.emit(obj.docAttachmentFileId);
        }
      },
    });
  }

  deleteInlineAttachment(obj: any): void {
    const [item] = this.attachedFiles.filter((x) => {
      return x.name == obj.name;
    });

    if (item) this.attachedFiles.splice(this.attachedFiles.indexOf(item), 1);
    this.attachedFiles = [...this.attachedFiles];
    this.msg.success('Document deleted successfully!')
    this.fileData.emit(this.attachedFiles);
  }

  downloadAttachment(data: any): void {
    const isSaveAs = data.fileUrl.includes('/bps') || data.fileUrl.includes('/dms') ? true : false;
    data.fileUrl = _.replace(data.fileUrl, this.downloadEndpoint, '');
    this.attachmentsService.downloadAttachment(data.fileUrl, this.downloadEndpoint, data.docAttachmentFileId).subscribe((response : any) => {
      if (isSaveAs) saveAs(response, data.originalFileName);
      else {
        const blob = new Blob([response], { type: data.mime });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.download = data.originalFileName;
        anchor.href = url;
        anchor.click();
      }
    });
  }

  isUploadEnabled() {
    const isEnabled = this.docType === null || this.docType?.length <= 0 ? false : true;
    return isEnabled;
  }

  uploadDocuments(uploadFiles:any): void {
    if (this.version && this.version != 1) {
      this.version = this.version != null ? Number(this.version).toFixed(1) : null;
      this.actionUrl = `${this.baseUrl}/api/v1/attachments/upload/${this._id}--${this.version}/${this.module}${this.subModule}/${(this.docType)? this.docType :  "product"}`;
    } else {
      this.actionUrl = `${this.baseUrl}/api/v1/attachments/upload/${this._id}/${this.module}${this.subModule}/${(this.docType)? this.docType :  "product"}`;
    }
    if (uploadFiles?.length > 0 && this._id) {
      this.attachmentsService.uploadDocumentsArray(this.actionUrl, uploadFiles).then((res) => {
        uploadFiles.forEach((file: any) => file.status = UploadStatus.DONE);
        this.attachedFiles = [...this.attachedFiles];
        this.uploadComplete.emit({ success: true, response: res });
      }, err => {
        uploadFiles.forEach((file: any) => file.status = UploadStatus.PENDING);
        this.attachedFiles = [...this.attachedFiles];
        this.isSpinning = false;
        this.uploadComplete.emit({ success: false, error: err });
        this.msg.error(err.status);
      });
    } else {
      this.uploadComplete.emit({ success: true, message: 'No files to upload' });
    }
  }

  uploadAmendDocument(): void {
    console.log('uploadAmendDocument called');
    console.log('currentAction:', this.currentAction);
    console.log('riskStatus:', this.riskStatus);
    console.log('attachedFiles:', this.attachedFiles);
    const uploadFiles = this.attachedFiles.filter((file: any) => file.status == UploadStatus.PENDING);
    console.log('uploadFiles with PENDING status:', uploadFiles);
    uploadFiles.map((file: any) => file.status = UploadStatus.UPLOADING);
    if (uploadFiles?.length > 0) {
      // Always upload directly — amend API is called upstream in header-tab before this method is reached
      console.log('Uploading documents directly');
      this.uploadDocuments(uploadFiles);
    } else {
      console.log('No PENDING files to upload');
    }
  }

  getDocumentsDetails() {
    let url = '';
    if (this.version && this.version != 1) {
      this.version != null ? Number(this.version?.version).toFixed(1) : null;
      url = `${this.baseUrl}/api/v1/attachments/${this._id}--${this.version}/${this.module}${this.subModule}/details`;
     } else {
      url = `${this.baseUrl}/api/v1/attachments/${this._id}/${this.module}${this.subModule}/details`;
     }
    if (this._id) {
      this.attachmentsService.getDocumentsDetailsForRequestAndModule(url).subscribe((res : any) => {
        res.forEach((file : any) => this.updateFileParam(file));
        this.attachedFiles = _.cloneDeep(res);
        this.attachedFiles.forEach((file) => {
          this.updateFileParam(file);
          // Keep existing files as DONE in amend mode — they are displayed for reference.
          // Only newly dropped/selected files will be PENDING and re-uploaded under the new ID.
        });
        this.getFileList.emit(this.attachedFiles);
        this.isSpinning = false;
      });
    }
  }

  updateFileParam(file: any) {
    if (!file.originalFileName.includes(file.fileType))
    file.originalFileName = file.originalFileName;
    file.name = file.originalFileName;
    file.status = UploadStatus.DONE;
    file.showDownload = true;
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
    
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleDroppedFiles(files);
    }
    this.getFileList.emit(files);
  }

  private handleDroppedFiles(files: FileList): void {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      this.processDroppedFile(file);
    }
  }

  private processDroppedFile(file: any): void {
    const mockItem = {
      file: file,
      onProgress: () => {},
      onSuccess: () => {},
      onError: () => {}
    };
    this.customUploadReq(mockItem);
  }

  customUploadReq = (item: any): any => {
      const file = item.file;
    if (!this.isValidFileType(file.type)) {
      this.msg.error('Invalid file type. Only XLSX/XLS/CSV/PDF/WORD/JPEG/JPG/PNG files are allowed.');
      return;
    }

     if (this.attachedFiles.length >= this.maxFiles) {
      this.msg.warning(`Maximum ${this.maxFiles} files can be attached.`);
      return;
    }

    const fileSizeMB = file.size / 1024 / 1024;
    if (Math.ceil(fileSizeMB) > this.maxFileSizeMB) {
      this.msg.error(`File size exceeds ${this.maxFileSizeMB} MB limit.`);
      return;
    }

    const isDuplicate = this.attachedFiles.some(existingFile => 
      existingFile.originalFileName === file.name || existingFile.name === file.name
    );
    if (isDuplicate) {
      this.msg.error(`File "${file.name}" already exists. Please select a different file.`);
      return;
    }

    file.status = UploadStatus.PENDING;
    file.docType = this.docType;
    file.originalFileName = file.name;
    this.attachedFiles.push(file);
    this.getFileList.emit([file]);

    // For amend action: only stage the file as Pending.
    // The actual upload is triggered by Save/Submit button via uploadDocuments().
    if (this._id && this.currentAction !== 'amend') {
      this.isSpinning = true;
      this.uploadAmendDocument();
    }
  }

  isValidFileType(fileType: string): boolean {
    const allowedTypes = [
      'image/png', 'image/jpeg', 'application/pdf',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel', 'text/csv',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword'
    ];
    return allowedTypes.includes(fileType);
  }

  uploaderValidation(fileType: any, showMsg: boolean = true): boolean {
    let allowedFileTypes = this.nzFileType.split(',');
    let FileTypeObj: any = FileTypes;
    let result;
    let flag = false;

    allowedFileTypes.forEach((type) => {
      if (FileTypeObj[type]) {
        let temp = (FileTypeObj[type]).split(',');
        result = temp.find((val: any) => val == fileType);

        if (result) {
          flag = true;
        }
      }
    });

    if (!flag) {
      if (showMsg)
        this.msg.error(`Invalid file type selected. Please select files of type: ${this.nzFileType}`);
      return flag;
    }

    return flag;
  }

}

enum UploadStatus {
  PENDING = "Pending",
  UPLOADING = "Uploading",
  DONE = "Done"
}

const FileTypes = {
  PNG: "PNG,png,image/png",
  "image/png": "PNG,png,image/png",
  JPEG: "JPEG,jpg,JPG,jpeg,image/jpeg",
  "image/jpeg":"JPEG,jpg,JPG,jpeg,image/jpeg",
  PDF: "application/pdf",
  "application/pdf": "application/pdf",
  XLSX: "xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  XLS: "xls,application/vnd.ms-excel",
  "application/vnd.ms-excel": "xls,application/vnd.ms-excel",
  CSV: "csv,text/csv",
  "text/csv": "csv,text/csv",
  DOCX: "docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  DOC: "doc,application/msword",
  "application/msword": "doc,application/msword"
}